<template>
  <div>
    <el-row>
      <div class="flex justify-between items-center gap-2.5">
        <div class="flex flex-col items-start gap-1.5 w-1/2">
          <span>Before</span>
          <div class="form-group w-full">
            <el-input class="w-full" type="text" v-model="field.question_before" />
          </div>
        </div>
        <div class="flex flex-col items-start gap-1.5 w-1/2">
          <span>After</span>
          <div class="w-full">
            <el-input class="w-full" type="text" v-model="field.question_after" />
          </div>
        </div>
      </div>

      <el-col class="pt-1.5 !space-y-2">
        <span class="">
          {{ title }}
        </span>
        <div class="form-group pt-1">
          <el-input type="textarea" v-model="field.question_text" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    props: ['field', 'title'],
    data() {
      return {};
    },
  };
</script>

<style lang="scss"></style>
